<template>
    <poverty-visualization :charts="charts" :area-chart="areaChart" :line-chart="lineChart" :title="title" :y-domain="yDomain"></poverty-visualization>
</template>
<script>
    import PovertyVisualization from './PovertyVisualization';
    export default{
        data: function(){
            return {
                title: 'Tasa de Atención Médica',
                yDomain: [0,100],
                charts: [
                    {
                        id: 'zona',
                        title: 'Zonas Urbanas y Rurales',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSe0pj-GxQ920_Np-F1u7mib3rLbQgCl7Dd8pEuC6zubHowV2hACL89HszYkVsH0J0MpoWQW4I2ru7e/pub?gid=0&single=true&output=csv',
                        countryFile: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQPQZISNeSR4NIa01XRKTHaAAenpiiQ3hxQg8V5VKqD1pSy5cPnJUEZdSTGiYAaw9pPMPxzRuebTmFn/pub?gid=0&single=true&output=csv',
                        dimensions: ['nom_reg','zona']
                    },
                    {
                        id: 'sexo',
                        title: 'Género',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vRUxrMzlAqQFLF3hRgNdr6OlM_zYknAyH5RssnI6abC1Qkd6Rw3yFI_DqfBs76tlezZnkuAyZJueU3M/pub?gid=0&single=true&output=csv',
                        countryFile: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vT560noVk5oMh7AJSBRuPHaco7b7kFgulO1H0DNq6nEfphLBmpTsR4g3AKWwfY44FIFIr56KAR0hHtI/pub?gid=0&single=true&output=csv',
                        dimensions: ['nom_reg','sexo']
                    },
                    {
                        id: 'pueb_indig',
                        title: 'Pueblos Indigenas',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSwDKa5qQ-2iJd9hz5O8WmYZ4OVirVEg24cjqeiadHPDP3KD0Kyiv5uVugBNXlw7jlHQby0KCBFZlWj/pub?gid=0&single=true&output=csv',
                        countryFile: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQJ9iEIvS1bYOwk08MqclP3d0M2owmYlGeyJPn5df9YPOa_Jids8vrL1zixm0YGJuJ_3qEpjBkssbOd/pub?gid=0&single=true&output=csv',
                        dimensions: ['nom_reg','pueb_indig']
                    },
                    {
                        id: 'migrantes',
                        title: 'Migrantes',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTb0Majw2nYbX22EHKDM6hUIbPOj1QVaAia13OH9Zr_zc8na-Hko582y9wv6p8SnoHO0SYlBTszt-Xh/pub?gid=0&single=true&output=csv',
                        countryFile: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTSBjb220YlL5bvm-LHBM4Z87M1bzHybRNZbGLasLt2HhcnaNJdvXVnbiCd-sL-vSqWQXFqfzGPb79W/pub?gid=0&single=true&output=csv',
                        dimensions: ['nom_reg','migrantes']
                    },
                    {
                        id: 'edades',
                        title: 'Rango Etario',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSyqwbi2PtFqTNHgeJvNhDEEy8K_tjnZgw1kJXzsTIliR4N7ForAoV4d_Qz3njKi7RAyqQH6hY2YIzl/pub?gid=0&single=true&output=csv',
                        countryFile: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTITfBz1H_bKSx7BOsx-DbXrB1YOJX2lwpHCo7BGOh-_sZGEAm3qbX8OghcUS8spVHKPBi4XuMezW60/pub?gid=0&single=true&output=csv',
                        dimensions: ['nom_reg','edades']
                    },
                    {
                        id: 'quintil',
                        title: 'Quintiles',
                        file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSs01umqdQgYzbnM4nxhFIYvb02ZJXnZwownmKA_vYqkdCXVmSZbO3G1MM15CvSXYrLpjIYqKduc3Xh/pub?gid=0&single=true&output=csv',
                        countryFile: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vRNA-t2SdkVCDR7ZyiPddGu5IPPtTe5hFeyMJrXM_c1esr7FsLUbE8g-bk0sldvacQQkminxqIGBzvC/pub?gid=0&single=true&output=csv',
                        dimensions: ['nom_reg','quintil']
                    }
                ],
                areaChart:{
                    file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQjHaIEgdFJWZzN72413axqpvCC_JGqN9K_ncKc5bwCE_JtQ9BmTfF1kTmAj8u9d1slXQpSJRx6TT7E/pub?gid=0&single=true&output=csv'
                },
                lineChart:{
                    file: 'https://docs.google.com/spreadsheets/d/e/2PACX-1vRFS8xbv4_XzIeEYiYI5MESxjja_JSD8lTQNX-idAaN03md33lOx2AyVXVZIc_CbvFJBqgQOedx3rwD/pub?gid=0&single=true&output=csv'
                }
            }
        },
        components: {
            PovertyVisualization
        }

    }
</script>


// WEBPACK FOOTER //
// src/js/Components/Visualizations/MedicalAttentionsVisualization.vue